import { useEffect, useState } from "react";
import { Flame, X } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

/** Sticky top banner: "Founding 10 — X spots left at £14 lifetime Pro".
 *  Auto-hides when slots are exhausted. Dismissable per session. */
export default function FoundingBanner() {
  const [stats, setStats] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("founding_dismissed") === "1") {
      setDismissed(true);
    }
    api.get("/founding/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (dismissed || !stats?.active || stats.remaining <= 0) return null;

  const close = () => {
    sessionStorage.setItem("founding_dismissed", "1");
    setDismissed(true);
  };

  return (
    <Link
      to="/pricing?founding=1"
      onClick={() => {/* let Link handle nav */}}
      className="sticky top-0 z-50 flex items-center justify-center gap-3 border-b border-orange-500/30 bg-gradient-to-r from-orange-500/15 via-amber-500/10 to-orange-500/15 px-4 py-2 text-sm backdrop-blur transition-colors hover:from-orange-500/25 hover:via-amber-500/20 hover:to-orange-500/25"
      data-testid="founding-banner"
    >
      <Flame className="h-4 w-4 shrink-0 text-orange-400" />
      <span className="min-w-0 truncate text-xs text-foreground sm:text-sm">
        <strong className="text-orange-400">🚀 Zuntria is here</strong> —{" "}
        <strong>Pro from £14.99/month</strong><span className="hidden sm:inline">. Find clients, get paid weekly →</span>
      </span>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); close(); }}
        className="ml-2 rounded-full p-1 text-muted-foreground hover:bg-white/10 hover:text-foreground"
        aria-label="Dismiss"
        data-testid="founding-dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </Link>
  );
}
